import {Type} from "@angular/core";
import {QueAdditionalInformationComponent} from "../components/questions/que-additional-information/que-additional-information.component";
import {QueFinalCardComponent} from "../components/questions/que-final-card/que-final-card.component";
import {QueHearAboutUsComponent} from "../components/questions/que-hear-about-us/que-hear-about-us.component";
import {QueHomeBuyComponent} from "../components/questions/que-home-buy/que-home-buy.component";
import {QueHomeCostComponent} from "../components/questions/que-home-cost/que-home-cost.component";
import {QueHomeFeaturesComponent} from "../components/questions/que-home-features/que-home-features.component";
import {QueLogInComponent} from "../components/questions/que-log-in/que-log-in.component";
import {QuePhoneInputComponent} from "../components/questions/que-phone-input/que-phone-input.component";
import {QueTimelineComponent} from "../components/questions/que-timeline/que-timeline.component";
import {QueUserAddressVerifyComponent} from "../components/questions/que-user-address-verify/que-user-address-verify.component";
import {QueBuyingPreferenceComponent} from "../components/questions/que-buying-preference/que-buying-preference.component";
import {QueUserAddressComponent} from "../components/questions/que-user-address/que-user-address.component";
import {
  QueConditionAdditionalBathroomComponent,
  QueConditionBathroomComponent,
  QueConditionFlooringComponent,
  QueConditionHomePaintComponent,
  QueConditionKitchenComponent,
  QueConditionOverallComponent
} from "../components/questions/que-condition-base/que-condition-base.component";
import {QueBasementComponent} from "../components/questions/que-basement/que-basement.component";
import {QueRemodeledLocationsComponent} from "../components/questions/que-remodeled-locations/que-remodeled-locations.component";
import {QueNeutralColorPaintComponent} from "../components/questions/que-neutral-color-paint/que-neutral-color-paint.component";
import {QueContactInputComponent} from "../components/questions/que-contact-input/que-contact-input.component";
import {QueThankYouComponent} from "../components/questions/que-thank-you/que-thank-you.component";
import {QueHomeInfoUpdateComponent} from "../components/questions/que-home-info-update/que-home-info-update.component";
import {QueUserAddressConfirmationComponent} from "../components/questions/que-user-address-confirmation/que-user-address-confirmation.component";

export enum OfferJourneyScreenName {
  home_facts = "home_facts",
  basement = "basement",
  add_address = "add_address",
  address_confirmation = "address_confirmation",
  simple_address_confirmation = "simple_address_confirmation",
  buying_with_selling = "buying_with_selling",
  buying_pref = "buying_pref",
  user_login_details = "user_login_details",
  add_phone = "add_phone",
  condition_kitchen = "condition_kitchen",
  condition_bathroom = "condition_bathroom",
  condition_flooring = "condition_flooring",
  condition_home_paint = "condition_home_paint",
  condition_overall = "condition_overall",
  condition_additional_bathroom = "condition_additional_bathroom",
  remodeled_location = "remodeled_location",
  wall_paint_intensity = "wall_paint_intensity",
  extra_facts = "extra_facts",
  home_worth = "home_worth",
  reach_survey = "reach_survey",
  end = "end",
  sale_timeline = "sale_timeline",
  home_remarks = "home_remarks",
  rl_thank_you = "rl_thank_you",
  rl_contact = "rl_contact"
}

// export const OfferJourneyMapping: Record<string, Type<unknown>> = {
//   $nia_user_address_confirmation: QueUserAddressVerifyComponent,
//   $nia_username: QueUserNameComponent,
//   $nia_user_address_entry: QueUserAddressComponent,
//   address_dedupe_end: QueAddressDedupeComponent,
//   ask_username_first: QueUserNameComponent,
//   user_address_entry: QueUserAddressComponent,
//   user_address_confirmation: QueUserAddressVerifyComponent,
//   not_serviceable: QueNotServiceableComponent,
//   user_name_entry: QueUserNameComponent,
//   ho_sale_timeline: QueTimelineComponent,
//   ho_future_seller_ques: QueHoFutureSellingComponent,
//   ho_home_worth: QueHomeCostComponent,
//   ho_buying_with_selling_ques: QueHomeBuyComponent,
//   ho_buying_preferences_ques: QueBuyingPreferenceComponent,
//   ho_agent_invitation_ques: QueInviteAgentComponent,
//   ho_login: QueLogInComponent,
//   ho_phone: QuePhoneInputComponent,
//   rl_contact: QueContactInputComponent,
//   ho_home_facts_consent: QueConfirmSkipHomeInfoComponent,
//   ho_update_home_facts: QueHomeInfoUpdateComponent,
//   ho_update_basement: QueBasementComponent,
//   ho_home_condition: QueAreaConditionComponent,
//   ho_home_extra_facts: QueHomeFeaturesComponent,
//   ho_home_remarks: QueAdditionalInformationComponent,
//   ho_reach_survey: QueHearAboutUsComponent,
//   ho_end: QueFinalCardComponent,
//   rl_thank_you: QueThankYouComponent,
//   goto_hifello: QueGoToFelloComponent,
//   ag_get_started: QueAgentGetStartedComponent,
//   ag_sale_timeline: QueAgentSaleTimelineComponent,
//   ag_home_worth: QueAgentHomeWorthComponent,
//   ag_details_login: QueAgentInfoComponent,
//   ag_invite_seller_confirmation: QueAgentInviteSellerComponent,
//   ho_invites_agent: QueHoInvitesAgentComponent,
//   ho_home_condition_kitchen: QueConditionKitchenComponent,
//   ho_home_condition_bathroom: QueConditionBathroomComponent,
//   ho_home_condition_flooring: QueConditionFlooringComponent,
//   ho_home_condition_home_paint: QueConditionHomePaintComponent,
//   ho_home_condition_overall: QueConditionOverallComponent,
//   ho_home_condition_additional_bathroom: QueConditionAdditionalBathroomComponent,
//   ho_home_condition_remodel: QueRemodeledLocationsComponent,
//   ho_home_condition_wall_paint_intensity: QueNeutralColorPaintComponent
// };

export const OfferJourneyScreenMapping: Record<string, Type<unknown>> = {
  [OfferJourneyScreenName.home_facts]: QueHomeInfoUpdateComponent,
  [OfferJourneyScreenName.basement]: QueBasementComponent,
  [OfferJourneyScreenName.add_address]: QueUserAddressComponent,
  [OfferJourneyScreenName.address_confirmation]: QueUserAddressVerifyComponent,
  [OfferJourneyScreenName.simple_address_confirmation]: QueUserAddressConfirmationComponent,
  [OfferJourneyScreenName.buying_with_selling]: QueHomeBuyComponent,
  [OfferJourneyScreenName.buying_pref]: QueBuyingPreferenceComponent,
  [OfferJourneyScreenName.user_login_details]: QueLogInComponent,
  [OfferJourneyScreenName.add_phone]: QuePhoneInputComponent,
  [OfferJourneyScreenName.condition_kitchen]: QueConditionKitchenComponent,
  [OfferJourneyScreenName.condition_bathroom]: QueConditionBathroomComponent,
  [OfferJourneyScreenName.condition_flooring]: QueConditionFlooringComponent,
  [OfferJourneyScreenName.condition_home_paint]: QueConditionHomePaintComponent,
  [OfferJourneyScreenName.condition_overall]: QueConditionOverallComponent,
  [OfferJourneyScreenName.condition_additional_bathroom]: QueConditionAdditionalBathroomComponent,
  [OfferJourneyScreenName.remodeled_location]: QueRemodeledLocationsComponent,
  [OfferJourneyScreenName.wall_paint_intensity]: QueNeutralColorPaintComponent,
  [OfferJourneyScreenName.extra_facts]: QueHomeFeaturesComponent,
  [OfferJourneyScreenName.home_worth]: QueHomeCostComponent,
  [OfferJourneyScreenName.reach_survey]: QueHearAboutUsComponent,
  [OfferJourneyScreenName.end]: QueFinalCardComponent,
  [OfferJourneyScreenName.sale_timeline]: QueTimelineComponent,
  [OfferJourneyScreenName.home_remarks]: QueAdditionalInformationComponent,
  [OfferJourneyScreenName.rl_thank_you]: QueThankYouComponent,
  [OfferJourneyScreenName.rl_contact]: QueContactInputComponent
};
